import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { Subject } from 'rxjs';
// import { GoogleAnalyticsService } from '../ngx-google-analytics/services/google-analytics.service';
import { IAppConfig } from './config/app-config.model';
import { APP_CONFIG } from './config/app-config.service';
// import mapGoogleAnalyticRouter from './mapGoogleAnalyticRouter';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private history: string[] = [];
  private backSubject = new Subject();
  private lastURL: string | undefined | null = null;
  isLoggedIn = false;

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
    private router: Router,
    // protected $gaService: GoogleAnalyticsService
  ) { 
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(this.lastURL){
          const action = this.lastURL.replace(event.urlAfterRedirects, '');
          if(action === '#back'){
            setTimeout(() => {
              this.backSubject.next(null);
            }, 300);
          }
          
        }

        this.lastURL = event.urlAfterRedirects;
        
        // Do not add hash url (#) to history
        if(event.urlAfterRedirects && !event.urlAfterRedirects.includes('#')){
          this.history.push(event.urlAfterRedirects);
          // scroll to top
          window.scrollTo(0, 0);

          // this.submitGA(event);
        }
      }
    })
  }

  setIsLoggedIn(value: boolean){
    this.isLoggedIn = value;
  }

  initialGA = false;
  // submitGA(event: NavigationEnd){    
  //   if(!this.initialGA && this.$gaService.isAutoRun()){
  //     this.initialGA = true;
  //     return;
  //   }
  //   const gaData = mapGoogleAnalyticRouter(event.urlAfterRedirects);

  //   this.$gaService.pageView(gaData.path, gaData.title, undefined, {
  //     dimension1: this.isLoggedIn ? 'User' : 'Anonymous'
  //   });
  // }

  // gaEvent(eventName: string, category: string, label: string){
  //   this.$gaService.event(eventName, category, label);
  // }

  // gaPageView(path: string, title?: string, location?: string, options?: Object){
  //   this.$gaService.pageView(path, title, location, options)
  // }

  isMobile(): boolean{
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); 
  }

  isDesktop(): boolean{
    return !this.isMobile();
  }

  isMobileUrl(url: string): boolean{
    return /(\/|#|^)m(\/|$)/i.test(url);
  }

  isDesktopUrl(url: string): boolean{
    return !this.isMobileUrl(url);
  }

  mobileUrl(url: string): string{
    let path = url.replace(window.location.origin, '').replace(/^\//, '');
    if(this.config && this.config.webAppPathName && this.config.webAppPathName !== '/'){
      path = path.replace(this.config.webAppPathName.replace(/(^\/|\/$)/g, ''), '');
    }

    if(this.isMobileUrl(path)) return path;

    if(!path) return 'm';

    path = `m/${path}`;
    path = path.replace(/\/+/g, '/').replace(/\/$/, '');
    return path;
  }

  desktopUrl(url: string): string{
    let path = url.replace(window.location.origin, '').replace(/^\//, '');
    if(this.config && this.config.webAppPathName && this.config.webAppPathName !== '/'){
      path = path.replace(this.config.webAppPathName.replace(/(^\/|\/$)/g, ''), '');
    }

    path = path.replace(/^\//, '');

    if(this.isDesktopUrl(path)) {
      return path;
    }

    path = path.replace(/(#\/|\/|#|^)m(\/|$)/, '/').replace(/^\//, '');
    path = path.replace(/\/+/g, '/').replace(/(^\/|\/$)/g, '');
    return path;
  }

  disableRedirectMobilePlatform = true;
  url(path: string): string{
    if(!this.disableRedirectMobilePlatform && this.isMobileUrl(window.location.href)){
      return this.mobileUrl(path);
    }

    return path;
  }

  back(): void {
    const currentUrl = this.history.pop();
    if (this.history.length > 0) {
      const backUrl = this.history.pop();
      this.router.navigateByUrl(backUrl || '');
    } else {
      this.router.navigateByUrl('/')
    }
  }

  onBrowserBack(){
    return this.backSubject;
  }

  captureBrowserBackEvent(){
    const currentRouterURL = this.router.url;
    let newUrl = currentRouterURL.replace('#back', '') + '#back';

    setTimeout(() => {
      this.router.navigateByUrl(this.url(newUrl));
    }, 100);
  }
}
